module.exports = __webpack_public_path__ + "static/media/1.57f1a1f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16111/1.jpg
// module id = 538
// module chunks = 0